import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Rfq, RfqCreate, RfqFilter } from '../data/rfq';

export function createRfqService(client: AxiosInstance) {
  return createCrudService<Rfq, RfqCreate, RfqFilter>(
    client,
    '/purchase/Rfq',
    'id',
  );
}

export type RfqService = CrudService<Rfq, RfqCreate, RfqFilter>;
